import React from 'react';

/**
 * Modal shown when the user's session is about to expire due to inactivity.
 * NIST 800-171 3.1.10 — Session lock after period of inactivity.
 */
export default function IdleWarningModal({ remainingSeconds, onStayLoggedIn, onLogout }) {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${String(seconds).padStart(2, '0')}`
    : `${seconds}s`;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      fontFamily: 'JetBrains Mono, monospace',
    }}>
      <div style={{
        background: 'var(--bcore-bg-secondary, #242424)',
        border: '1px solid var(--bcore-border, #333)',
        borderRadius: '12px',
        padding: '32px 40px',
        maxWidth: '440px',
        width: '90%',
        textAlign: 'center',
      }}>
        <div style={{
          fontSize: '14px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: '#f59e0b',
          marginBottom: '16px',
        }}>
          Session Expiring
        </div>

        <p style={{
          color: 'var(--bcore-text-primary, #fff)',
          fontSize: '13px',
          lineHeight: '1.6',
          margin: '0 0 8px',
        }}>
          Your session will expire due to inactivity in
        </p>

        <div style={{
          fontSize: '32px',
          fontWeight: 700,
          color: '#f59e0b',
          margin: '12px 0 24px',
          fontFamily: 'Kode Mono, JetBrains Mono, monospace',
        }}>
          {timeDisplay}
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={onStayLoggedIn}
            style={{
              padding: '10px 24px',
              borderRadius: '100px',
              border: 'none',
              background: 'var(--bcore-accent, #d6e200)',
              color: '#000',
              fontSize: '12px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              fontFamily: 'JetBrains Mono, monospace',
            }}
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 24px',
              borderRadius: '100px',
              border: '1px solid var(--bcore-border, #333)',
              background: 'transparent',
              color: 'var(--bcore-text-dim, #888)',
              fontSize: '12px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              fontFamily: 'JetBrains Mono, monospace',
            }}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
